import { Stack } from '@mui/material';
import { useEffect } from 'react';

import { getExternalInvitationSurveys } from '@/domain/external-invitation-survey/actions/get-external-invitation-surveys.action';
import { getSurveysResults } from '@/domain/external-invitation-survey/actions/get-surveys-results.action';
import { getProjectsFestival } from '@/domain/project-festival/actions/get-projects-festival.action';
import { getProjectsTour } from '@/domain/project-tour/actions/get-projects-tour.action';
import { getProjectsVenue } from '@/domain/project-venue/actions/get-projects-venue.action';
import { FSModal } from '@/ui/components/modal/FSModal';
import { FSModalTitle } from '@/ui/components/modal/FSModalTitle';
import { useAppDispatch } from '@/ui/hook/store';
import { translate } from '@/ui/i18n';

import { CreateNewSurveyForm } from './components/CreateNewSurveyForm';
import { SurveyList } from './components/SurveyList';
import { Tabs } from './components/Tabs';

export function ModalSurveys({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const loadData = async () => {
      await Promise.all([
        dispatch(getProjectsFestival()),
        dispatch(getProjectsVenue()),
        dispatch(getProjectsTour()),
      ]);
      await dispatch(getExternalInvitationSurveys());
      await dispatch(getSurveysResults());
    };
    if (open) {
      loadData();
    }
  }, [open, dispatch]);

  return (
    <FSModal
      open={open}
      onClose={onClose}
      maxWidth={1000}
      showCloseButton={true}
    >
      <Stack sx={{ gap: 3 }}>
        <FSModalTitle title={translate('Surveys.modal-title')} />
        <Tabs />
        <CreateNewSurveyForm />
        <SurveyList />
      </Stack>
    </FSModal>
  );
}
